/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-duplicates */
import { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns';
import ptBr from 'date-fns/locale/pt-BR';
import { useDispatch, useSelector } from 'react-redux';
import { Column, Filters as IFilters } from 'react-table';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';

import { Table } from 'components/Table';
import { Breadcrumb } from 'components/Breadcrumb';
import { StatusTag } from 'components/styled/StatusTag';
import { ApplicationState } from 'store/store.inteface';
import {
  searchClaimsAction,
  setTimelineClaimId,
} from 'store/modules/claims/actions';
import { IClaim, SearchClaim } from 'store/modules/claims/types';
import { claimTypeOptions } from 'utils/claimTypeOptions';
import { MdOutlineDescription, MdTimeline } from 'react-icons/md';
import { ModalTimeline } from 'components/ModalTimeline';
import { STATUS_LIST } from 'utils/statusList';
import { STATUS_BROKER } from 'utils/statusEnum';
import { ROLES } from 'config/roles';
import { Action } from './Action';
import { ActionIcons } from './styles';
import { Filters } from './Filters';

export const initFilterState = [
  {
    id: 'number',
    value: '',
  },
  {
    id: 'cp',
    value: '',
  },
  {
    id: 'franchise',
    value: '',
  },
  {
    id: 'coverage',
    value: '',
  },
  {
    id: 'uf',
    value: '',
  },
  {
    id: 'status',
    value: '',
  },
  {
    id: 'statusBroker',
    value: '',
  },
  {
    id: 'createdAt',
    value: '',
  },
];

const DateCell = ({ value }) => {
  const formattedDate = format(new Date(value), 'dd/MM/yyyy', {
    locale: ptBr,
  });
  return <div>{formattedDate}</div>;
};

const StatusCell = ({ value }) => {
  const tagType = claimTypeOptions[value || 'default'];
  return <StatusTag variant={tagType?.tagType}>{tagType?.value}</StatusTag>;
};

const ActionIconsCell = ({ onTimelineClick, onProcessClick }) => {
  return (
    <ActionIcons>
      <Action
        onClick={onTimelineClick}
        icon={<MdTimeline size={24} />}
        color="#FF5501"
      >
        Timeline
      </Action>
      <Action
        icon={<MdOutlineDescription size={22} />}
        color="#0078FF"
        onClick={onProcessClick}
      >
        Processo
      </Action>
    </ActionIcons>
  );
};

export const Claim = () => {
  const dispatch = useDispatch();
  const history = useHistoryWithHost();

  const [datesValue, setDatesValue] = useState<any>([null, null]);
  const [groupedStatusValue, setGroupedStatusValue] = useState<any>();

  const claims = useSelector(
    (state: ApplicationState) => state.claims.searchClaims,
  );
  const { stores } = useSelector(
    (state: ApplicationState) => state.storesContext,
  );
  const { rolesList } = useSelector((state: ApplicationState) => state.roles);
  const [filters, setFilters] = useState<IFilters<IClaim>>(initFilterState);

  useEffect(() => {
    if (stores.length > 0 || rolesList[0] === ROLES.MANAGEMENT) {
      dispatch(searchClaimsAction());
    }
  }, [dispatch, stores, rolesList]);

  const cleanFilters = () => {
    setFilters(initFilterState);
    setDatesValue([null, null]);
    setGroupedStatusValue({ label: 'Nenhum', value: '' });
  };

  const columns = useMemo<Column<SearchClaim>[]>(
    () => [
      {
        Header: 'NUMERO DE SINISTRO',
        accessor: 'number',
        width: 77,
      },
      {
        Header: 'LOJA',
        accessor: 'franchise',
        width: 180,
      },
      {
        Header: 'ESTADO',
        accessor: 'uf',
        width: 120,
      },
      {
        Header: 'DATA DE COMUNICAÇÃO',
        accessor: 'createdAt',
        width: 90,
        Cell: DateCell,
        filter: (rows, id: any) => {
          if (datesValue[0] !== null && datesValue[1] !== null) {
            return rows.filter(
              (row: any) =>
                new Date(row.values[id]).setHours(0, 0, 0) <=
                  datesValue[1]?.setHours(23, 59, 59) &&
                new Date(row.values[id]).setHours(0, 0, 0) >=
                  datesValue[0]?.setHours(0, 0, 0),
            );
          }
          return rows;
        },
      },
      {
        Header: 'COBERTURA',
        accessor: 'coverage',
      },
      {
        Header: 'STATUS',
        accessor: 'status',
        width: 100,
        Cell: StatusCell,
        filter: rows => {
          if (groupedStatusValue?.type === STATUS_LIST.gestao) {
            return rows.filter(
              (row: any) => row.values.status === groupedStatusValue?.label,
            );
          }
          return rows;
        },
      },
      {
        Header: 'STATUS CORRETORA',
        accessor: 'statusBroker',
        filter: rows => {
          if (groupedStatusValue?.type === STATUS_LIST.corretora) {
            if (groupedStatusValue?.label === STATUS_BROKER.pendent) {
              return rows.filter((row: any) =>
                row.values.statusBroker.includes(
                  `${groupedStatusValue?.label} `,
                ),
              );
            }
            return rows.filter(
              (row: any) =>
                row.values.statusBroker === groupedStatusValue?.label,
            );
          }
          return rows;
        },
      },
      {
        Header: 'CP',
        accessor: 'cp',
      },
      {
        Header: 'AÇÕES',
        accessor: 'number',
        id: 'action',
        disableSortBy: true,
        width: 125,
        Cell: ({ row }) => (
          <ActionIconsCell
            onTimelineClick={() =>
              dispatch(setTimelineClaimId(row.original.id))
            }
            onProcessClick={() =>
              history.push(`/claim/${row.original.id}/process`)
            }
          />
        ),
      },
    ],

    [history, datesValue, groupedStatusValue],
  );

  return (
    <>
      <Breadcrumb />
      <Filters
        values={filters}
        setValues={setFilters}
        cleanFilters={cleanFilters}
        datesValue={datesValue}
        setDatesValue={setDatesValue}
        groupedStatusValue={groupedStatusValue}
        setGroupedStatusValue={setGroupedStatusValue}
      />
      <Table
        defaultSortBy={[
          {
            id: 'createdAt',
            desc: true,
          },
        ]}
        hiddenColumns={['cp', 'statusBroker']}
        columnFilters={filters}
        sorted
        columns={columns}
        data={claims}
      />
      <ModalTimeline showActions={false} />
    </>
  );
};
